import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useEffect, useMemo, useRef } from "react";
export const AEMComponentWrapper = memo(({ domQuerySelector }) => {
    const aemHtmlElementWrapper = document.querySelector(".aem-body__container");
    const aemHtmlElement = useMemo(() => aemHtmlElementWrapper?.querySelector(domQuerySelector) || document.createElement("div"), [domQuerySelector]);
    const rootElementRef = useRef(null);
    useEffect(() => {
        rootElementRef?.current?.appendChild(aemHtmlElement);
        return () => {
            aemHtmlElementWrapper?.appendChild(aemHtmlElement);
        };
    }, [aemHtmlElement]);
    return (_jsx(_Fragment, { children: _jsx("div", { "data-testid": "aemComponentWrapper", ref: rootElementRef }) }));
});
//# sourceMappingURL=AEMComponentWrapper.js.map